import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  data: [],
  indicatorIndex: 0,
  isFetching: false,
  left: 0,
  open: false,
  selectedIndex: -1,
  top: 0,
  anchorId: null,
};

export default function suggest(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SUGGEST_REQUEST_DATA:
      return Object.assign({}, state, {
        open: true,
        isFetching: true,
      });

    case ActionTypes.SUGGEST_RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        open: true,
        data: action.data,
      });

    case ActionTypes.SUGGEST_SET_ANCHOR:
      return Object.assign({}, state, {
        top: action.top,
        left: action.left,
        anchorId: action.anchorId,
      });

    case ActionTypes.SUGGEST_SET_INDICATOR_INDEX:
      return Object.assign({}, state, {
        indicatorIndex: action.indicatorIndex,
      });

    case ActionTypes.SUGGEST_SET_SELECTED_INDEX:
      return Object.assign({}, state, {
        selectedIndex: action.selectedIndex,
      });

    case ActionTypes.SUGGEST_CLOSE_AND_RESET:
      return Object.assign({}, state, {
        data: [],
        open: false,
        selectedIndex: -1,
      });

    default:
      return state;
  }
}
